export async function processImage(sourceImgData, manipulationCanvas, minThreshold, maxThreshold) {
    // DEBUG: console.log('HISTOGRAM PROCESSING IMAGE', sourceImgData);
    if (!sourceImgData) {
        return;
    }
    const width = sourceImgData.width;
    const height = sourceImgData.height;
    const src = new Uint32Array(sourceImgData.data.buffer);
    if (!manipulationCanvas) {
        return;
    }

    const canvas = manipulationCanvas;
    if (!canvas) {
        return;
    }
    const outctx = canvas.getContext("2d");
    const outImg = outctx.createImageData(width, height);
    const dst = new Uint32Array(outImg.data.buffer);
    // Image adjustment
    processCanvas(src, dst, minThreshold, maxThreshold, clampHistogram);
    processCanvas(dst, dst, minThreshold, maxThreshold, stretchHistogram);
    outctx.putImageData(outImg, 0, 0);

    // Histogram calculations
    let histBrightness = new Array(256).fill(0);
    let histR = new Array(256).fill(0);
    let histG = new Array(256).fill(0);
    let histB = new Array(256).fill(0);
    // Use the dst image to calculate histogram (stretches the histogram as we manipulate)
    // Per user feedback, disable this for now
    /*for (let i = 0; i < dst.length; i++) {
        let r = dst[i] & 0xFF;
        let g = (dst[i] >> 8) & 0xFF;
        let b = (dst[i] >> 16) & 0xFF;
        histBrightness[r]++;
        histBrightness[g]++;
        histBrightness[b]++;
        histR[r]++;
        histG[g]++;
        histB[b]++;
    }*/

    // Use the src image to calculate histogram (keeps histogram the same as we manipulate)
    // Per user feedback, use this method
    for (let i = 0; i < src.length; i++) {
        let r = src[i] & 0xff;
        let g = (src[i] >> 8) & 0xff;
        let b = (src[i] >> 16) & 0xff;
        histBrightness[r]++;
        histBrightness[g]++;
        histBrightness[b]++;
        histR[r]++;
        histG[g]++;
        histB[b]++;
    }

    let maxBrightness = 0;

    for (let i = 1; i < 256; i++) {
        if (maxBrightness < histBrightness[i]) {
            maxBrightness = histBrightness[i];
        }
    }

    await drawHistogram(maxBrightness, histBrightness, minThreshold, maxThreshold);
}

function clampHistogram(src, dst, options) {
    let brightness = 0;
    let minThreshold = options.minThreshold;
    let maxThreshold = options.maxThreshold;

    /*let avgGray = 0;
    for (let i = 0; i < dst.length; i++) {
        let r = src[i] & 0xff;
        let g = (src[i] >> 8) & 0xff;
        let b = (src[i] >> 16) & 0xff;
        avgGray += (r + g + b) / 3;
    }
    avgGray /= dst.length;*/

    for (let i = 0; i < dst.length; i++) {
        let r = src[i] & 0xff;
        let g = (src[i] >> 8) & 0xff;
        let b = (src[i] >> 16) & 0xff;

        // Clamp values
        if (r > maxThreshold) r = 255;
        else if (r < minThreshold) r = 0;
        if (g > maxThreshold) g = 255;
        else if (g < minThreshold) g = 0;
        if (b > maxThreshold) b = 255;
        else if (b < minThreshold) b = 0;

        dst[i] = (src[i] & 0xff000000) | (b << 16) | (g << 8) | r;
        let diff = dst[i] - src[i];
    }
}

// Stretch histogram so that the low threshold equals black
// and high threshold equals white. In effect, this increases
// contrast. Warning: This will also mean that there will be steps
// in the histogram.
function stretchHistogram(src, dst, options) {
    let brightness = 0;
    const minThreshold = options.minThreshold;
    const maxThreshold = options.maxThreshold;

    /*let avgGray = 0;
    for (let i = 0; i < dst.length; i++) {
        let r = src[i] & 0xff;
        let g = (src[i] >> 8) & 0xff;
        let b = (src[i] >> 16) & 0xff;
        avgGray += (r + g + b) / 3;
    }
    avgGray /= dst.length;*/

    for (let i = 0; i < dst.length; i++) {
        let r = src[i] & 0xff;
        let g = (src[i] >> 8) & 0xff;
        let b = (src[i] >> 16) & 0xff;

        // Contrast
        r = ((r - minThreshold) / (maxThreshold - minThreshold)) * 255;
        g = ((g - minThreshold) / (maxThreshold - minThreshold)) * 255;
        b = ((b - minThreshold) / (maxThreshold - minThreshold)) * 255;

        if (r > 255) r = 255;
        else if (r < 0) r = 0;
        if (g > 255) g = 255;
        else if (g < 0) g = 0;
        if (b > 255) b = 255;
        else if (b < 0) b = 0;

        dst[i] = (src[i] & 0xff000000) | (b << 16) | (g << 8) | r;
        let diff = dst[i] - src[i];
        if (i < 100 && diff != 0) {
            console.log("DST-SRC DIFF=", diff);
        }
    }
}

function processCanvas(src, dst, minThreshold, maxThreshold, func) {
    func(src, dst, {
        minThreshold: minThreshold,
        maxThreshold: maxThreshold,
    });
}

async function drawHistogram(maxBrightness, histBrightness, minThreshold, maxThreshold) {
    const canvasHistogram = document.getElementById("canvasHistogram");
    if (!canvasHistogram) {
        return;
    }
    const hctx = canvasHistogram.getContext("2d");
    let guideHeight = 8;
    let startY = canvasHistogram.height - guideHeight;
    let dx = canvasHistogram.width / 256;
    let dy = startY / maxBrightness;
    hctx.lineWidth = dx;
    hctx.fillStyle = "aliceblue";
    hctx.fillRect(0, 0, canvasHistogram.width, canvasHistogram.height);

    for (let i = 0; i < 256; i++) {
        let x = i * dx;
        hctx.strokeStyle = "#000000";
        hctx.beginPath();
        hctx.moveTo(x + hctx.lineWidth / 2, startY);
        hctx.lineTo(x + hctx.lineWidth / 2, startY - histBrightness[i] * dy);
        hctx.closePath();
        hctx.stroke();

        // Intensity guide
        hctx.strokeStyle = "rgb(" + i + ", " + i + ", " + i + ")";
        hctx.beginPath();
        hctx.moveTo(x + hctx.lineWidth / 2, startY);
        hctx.lineTo(x + hctx.lineWidth / 2, canvasHistogram.height);
        hctx.closePath();
        hctx.stroke();
    }

    // Draw minimum intensity clamp (vertical line and shaded box)
    let x = (minThreshold - 1) * dx;
    hctx.fillStyle = "#80808080";
    hctx.fillRect(0, 0, x + hctx.lineWidth / 2, startY);
    hctx.strokeStyle = "#4a40d480";
    hctx.beginPath();
    hctx.moveTo(x + hctx.lineWidth / 2, startY);
    hctx.lineTo(x + hctx.lineWidth / 2, 0);
    hctx.closePath();
    hctx.stroke();

    // Draw maximum intensity clamp (vertical line and shaded box)
    x = (maxThreshold + 1) * dx;
    hctx.fillStyle = "#80808080";
    hctx.fillRect(x + hctx.lineWidth / 2, 0, 256 * dx, startY);
    hctx.strokeStyle = "#4a40d480";
    hctx.beginPath();
    hctx.moveTo(x + hctx.lineWidth / 2, startY);
    hctx.lineTo(x + hctx.lineWidth / 2, 0);
    hctx.closePath();
    hctx.stroke();
}